(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.button = this.querySelector('[data-sticky-button]');
      this.variantLabel = this.querySelector('[data-sticky-variant]');
      this.button.addEventListener('click', this.onClick);
      this.section?.addEventListener('change', this.sync);
      window.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      this.update();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.section?.removeEventListener('change', this.sync);
      window.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
    }

    get mainButton() {
      return this.section?.querySelector('.buy-buttons-block .add-to-cart-button');
    }

    // Se calcula en vivo en cada scroll: el tema puede volver a pintar el bloque de compra al cambiar de variante.
    update = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const target = this.section?.querySelector('.buy-buttons-block');
        const scrolledPast = Boolean(target) && target.getBoundingClientRect().bottom < 0;
        const show = scrolledPast && this.mobile.matches;
        if (show) this.sync();
        this.classList.toggle('is-visible', show);
      });
    };

    sync = () => {
      const main = this.mainButton;
      if (main) {
        this.button.disabled = main.disabled;
        const text = main.querySelector('.add-to-cart-text__content')?.textContent.trim();
        if (text) this.button.textContent = text;
      }
      const checked = this.section?.querySelector('variant-picker input:checked');
      this.variantLabel.textContent = checked ? checked.value : '';
    };

    onClick = () => {
      const main = this.mainButton;
      if (main && !main.disabled) main.click();
    };
  }

  if (!customElements.get('sticky-add-to-cart')) {
    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }
  } catch(e) { console.error(e); }
})();

})();
